<template>
  <IQOS :systemDependency="mode" :title="$t('timing_settings.title')" required>
    <p class="iqos-comment qrw-paragraph-md mt-16 bold v1-grey-7-color">
      {{ $t("timing_settings.last_order") }}
    </p>
    <div class="time-inputs-row mt-8">
      <BaseUnitSelect
        v-model.number="closeLimitHours"
        class="w-100"
        style="width: 100%"
        :invalid="hasNoTimeGapForSelection"
        fullWidth
        :unitPlaceholder="$t('units.hours')"
      > 
        <option v-for="h in 24" :value="h - 1" :key="h">
          {{ h - 1 }}
        </option>
      </BaseUnitSelect>
      <BaseUnitSelect
        class="w-100 ml-8"
        style="width: 100%"
        fullWidth
        :invalid="hasNoTimeGapForSelection"
        v-model.number="closeLimitMinutes"
        :unitPlaceholder="$t('units.mins')"
      >
        <option v-for="m in 60" :value="m - 1" :key="m">
          {{ m - 1 }}
        </option>
      </BaseUnitSelect>
    </div>
    <!-- <BaseInput
      class="mt-8"
      type="number"
      @blur="save"
      v-model.number="edit_fields.close_time_limit"
      :placeholder="$t('timing_settings.time_ph')"
    /> -->

    <p class="iqos-comment qrw-paragraph-md mt-8">
      {{ $t("timing_settings.last_order_comment") }}
    </p>

    <BaseDivider color="v1-grey-6" class="mt-16" />

    <p class="iqos-comment qrw-paragraph-md mt-16 bold v1-grey-7-color">
      {{ $t("timing_settings.cook_time") }}
    </p>
    <div class="time-inputs-row mt-8">
      <BaseUnitSelect
        v-model.number="minTimeHours"
        class="w-100"
        :invalid="hasNoTimeGapForSelection"
        style="width: 100%"
        fullWidth
        :unitPlaceholder="$t('units.hours')"
      >
        <option v-for="h in 24" :value="h - 1" :key="h">
          {{ h - 1 }}
        </option>
      </BaseUnitSelect>
      <BaseUnitSelect
        class="w-100 ml-8"
        style="width: 100%"
        :invalid="hasNoTimeGapForSelection"
        fullWidth
        v-model.number="minTimeMinutes"
        :unitPlaceholder="$t('units.mins')"
      >
        <option v-for="m in 60" :value="m - 1" :key="m">
          {{ m - 1 }}
        </option>
      </BaseUnitSelect>
    </div>
    <p class="iqos-comment qrw-paragraph-md mt-8 v1-grey-7-color">
      {{ $t("timing_settings.cook_time_desc") }}
    </p>

    <p class="iqos-comment qrw-paragraph-md mt-16 v1-grey-7-color">
      {{ $t("timing_settings.cook_time_warning") }}
    </p>

    <p class="iqos-comment qrw-paragraph-md mt-16 orange-4-color" v-if="hasNoTimeGapForSelection">
      {{ $t("timing_settings.gap_warning") }}
    </p>  

    <template v-if="mode == 'delivery'">
      <BaseDivider color="v1-grey-6" class="mt-16" />

      <p class="iqos-comment qrw-paragraph-md bold mt-16 v1-grey-7-color">
        {{ $t("timing_settings.delivery_time") }}
      </p>
      <BaseUnitInput
        fullWidth
        :readonly="false"
        class="mt-8 w-100"
        :unitPlaceholder="$t('units.mins')"
        type="number"
        @blur="save"
        v-model.number="edit_fields.shipping_time"
        :placeholder="$t('timing_settings.time_ph')"
      />

      <p class="iqos-comment qrw-paragraph-md mt-8 v1-grey-7-color">
        {{ $t("timing_settings.delivery_time_comment") }}
      </p>

      <p class="iqos-comment qrw-paragraph-md mt-8 v1-grey-7-color">
        {{ $t("timing_settings.delivery_time_comment2") }}
      </p>
    </template>

    <!-- <IQOSActions
      :editing="editing"
      @edit="showEditUI"
      @cancel="hideEditUI"
      @accept="onEditFinish"
    /> -->
  </IQOS>
</template>


<script>
import IQOS from "@/components/IQOS.vue";
import IQOSActions from "@/components/IQOSActions.vue";
import BlackInput from "@/components/BlackInput.vue";

import moment from 'moment'

export default {
  components: {
    IQOS,
    IQOSActions,
    BlackInput,
  },
  props: {
    mode: String,
  },
  data() {
    return {
      edit_fields: {
        min_order_time: null,
        close_time_limit: null,
        shipping_time: null,
      },
    };
  },
  methods: {
    reset() {
      this.edit_fields.shipping_time = this.cafe.delivery.shipping_time || 15;
      this.edit_fields.close_time_limit =
        this.cafe[this.mode].close_time_limit || null;
      this.edit_fields.min_order_time =
        this.cafe[this.mode].min_order_time || null;
    },
    save() {
      if (this.mode == "delivery") {
        if (this.edit_fields.shipping_time)
          this.$store.commit(
            "setDeliveryShippingTime",
            this.edit_fields.shipping_time
          );
      }

      this.$store.commit("setModeMinOrderTime", {
        mode: this.mode,
        value: this.edit_fields.min_order_time,
      });

      if (this.edit_fields.close_time_limit)
        this.$store.commit("setCafeCloseTimeLimit", {
          mode: this.mode,
          close_time_limit: this.edit_fields.close_time_limit,
        });

      this.$store.dispatch("saveCafe");
    },
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    hasNoTimeGapForSelection() {
      const schedule = this.cafe[this.mode].schedule || this.cafe.schedule;

      console.log(schedule);

      const days = Object.values(schedule).filter(d => !!d._id);

      console.log(days);

      const noGapDay = days.some(d => {
        const sm = moment().hours(d.startHour).minutes(d.startMinute);
        const em = moment().hours(d.endHour).minutes(d.endMinute);

        if (sm.isAfter(em)) em.add(1, 'day');

        const min_order_point = moment(sm).add(this.edit_fields.min_order_time, 'minutes');
        const close_time_point = moment(em).subtract(this.edit_fields.close_time_limit, 'minutes');

        const max_bias = 10;

        if (em.diff(min_order_point, 'minutes') < max_bias) {
          return true;
        }

        if (close_time_point.diff(sm, 'minutes') < max_bias) {
          return true;
        }

        return false;
      });

      return noGapDay;
    },
    closeLimitHours: {
      get() {
        return Math.floor(this.edit_fields.close_time_limit / 60);
      },
      set(hrs) {
        this.edit_fields.close_time_limit =
          (this.edit_fields.close_time_limit % 60) + hrs * 60;

          this.save();
      },
    },
    closeLimitMinutes: {
      get() {
        return Math.floor(this.edit_fields.close_time_limit % 60);
      },
      set(mins) {
        this.edit_fields.close_time_limit =
          Math.floor(this.edit_fields.close_time_limit / 60) * 60 + mins;

          this.save();
      },
    },
    minTimeHours: {
      get() {
        return Math.floor(this.edit_fields.min_order_time / 60);
      },
      set(hrs) {
        this.edit_fields.min_order_time =
          (this.edit_fields.min_order_time % 60) + hrs * 60;

        this.save();
      },
    },
    minTimeMinutes: {
      get() {
        return Math.floor(this.edit_fields.min_order_time % 60);
      },
      set(mins) {
        this.edit_fields.min_order_time =
          Math.floor(this.edit_fields.min_order_time / 60) * 60 + mins;

          this.save();
      },
    },
  },
  mounted() {
    this.reset();
  },
};
</script>

<style>
.time-inputs-row {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
</style>